export default __webpack_public_path__ + "static/media/keyvis_logo_mob@2x.0e95ac34.png";